import { selectOne } from 'vevet-dom';
import getScrollValues from './getScrollValues';
import clamp from '../math/clamp';
import scrollTo from './scrollTo';
/**
 * Scroll to element
 */
export default function scrollToElement({ container = window, el, top = 0, left = 0, duration = 250, }) {
    return new Promise((resolve, reject) => {
        const startValues = getScrollValues(container);
        if (startValues) {
            const element = selectOne(el);
            if (element) {
                const bounding = element.getBoundingClientRect();
                const toTop = clamp(bounding.top + startValues.scrollTop - top, [0, Infinity]);
                const toLeft = clamp(bounding.left + startValues.scrollLeft - left, [0, Infinity]);
                scrollTo({
                    container,
                    top: toTop,
                    left: toLeft,
                    duration,
                }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                });
            }
            return;
        }
        reject();
    });
}
